import styled from 'styled-components'
import { Block, Button, Image } from '@mote/ui'

export const Root = styled(Block)(
  {
    boxSizing: 'border-box',
    position: 'relative',
    ['& *']: {
      fontFamily: "'DM Sans', sans-serif !important"
    }
  },
  props => (props.isMarginTopVisible ? { marginTop: 14 } : null)
)

export const ContentWrapper = styled(Block)({
  padding: 16,
  borderRadius: 8,
  backgroundColor: '#f6f6f9'
})

export const ActionButton = styled(Button).attrs({ variant: 'primary' })`
  background: #ffffff;
  justify-content: flex-start;

  & span.button-text {
    color: #232323;
    font-size: 14px;
  }

  &:hover,
  &:focus {
    background: #ffffff;

    filter: drop-shadow(0px 0px 13px rgba(0, 0, 0, 0.15));

    & span.button-text {
      color: #232323;
    }
  }
`

export const StyledImage = styled(Image).attrs({
  alt: 'loop-meme'
})`
  display: block;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`
